import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Config from '../../config/Config';
import { setInitialMyStepDetails } from '../../redux/mystep/mystep.actions';
import { setUserType } from '../../redux/userAuthentication/userAuth.actions';
import ErrorModal from '../common/errorModal';
import UserTypes from '../../utils/userTypes';

const Header = ({
	fullName,
	setInitialMyStepDetails,
	userPic,
	userType,
	setUserType,
}) => {
	const [name, setName] = useState('');

	useEffect(() => {
		document.getElementById('profileHeader');
		setInitialMyStepDetails();
	}, [setInitialMyStepDetails]);

	useEffect(() => {
		setName(fullName);
	}, [fullName]);

	return (
		<div className="step-def-header ">
			<section className="step-container align-stretch container ">
				<a
					href={
						userType === UserTypes.Junior
							? '/junior/dashboard'
							: userType === UserTypes.Parent
								? '/parent/dashboard'
								: '/mydashboard'
					}
					className="logoContainer"
				>
					<img
						className="img-responsive logo "
						style={{ backgroundColor: '#fff' }}
						src="https://storage.googleapis.com/assets.thehindustep.in/img/STEP_logo.png"
						alt="logo"
					/>
				</a>
				<div className="page-right-section">
					<div className="dashboard-page ">
						<div className="db-body ">
							<div id="profileHeader" className="user-header ">
								<div className="user-header-dp ">
									<a
										href='/mydashboard'>
										<img
											src={
												!!userPic ? userPic : `${Config.ASSETSPATH}/img/Proflie_pic.png`
											}
											alt="profile"
										/>
									</a>
								</div>
								<div className="user-header-links ">
									<a
										href='/mydashboard'
										className="UserNameText"
									>
										Hello, {name}
									</a>

									<a href="/logout" style={{ cursor: 'pointer' }}>
										<i className="fa fa-sign-out"></i>Logout
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<ErrorModal />
		</div>
	);
};

const mapStateToProps = (state) => {
	const { userType } = state.rootReducer.loginDetails;
	return {
		fullName:
			state.rootReducer.profileDetails.fullName ||
			state.rootReducer.userDetails.full_name ||
			state.rootReducer.parentDetails.parentName,
		o_level: state.rootReducer.myStepDetails.score.oLevel,
		userPic: state.rootReducer.loginDetails.userPic,
		userType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setInitialMyStepDetails: () => dispatch(setInitialMyStepDetails()),
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
